import { render, staticRenderFns } from "./PortalAnnouncements.vue?vue&type=template&id=6630d808&scoped=true&"
import script from "./PortalAnnouncements.vue?vue&type=script&lang=ts&"
export * from "./PortalAnnouncements.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6630d808",
  null
  
)

export default component.exports